import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import NewsState from './state';
import NewsMutations from './mutations';
import NewsGetters from './getters';
import { NewsService } from '../service';

const newsServece = new NewsService();

export default class NewsActions extends Actions<
  NewsState,
  NewsGetters,
  NewsMutations,
  NewsActions
> {
  async get_news() {
    try {
      const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const { current_page, limit } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit,
          page: current_page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_NEWS_LOADING(true);

      const { data, meta } = await newsServece.get_news(payload);

      this.mutations.SET_NEWS(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_NEWS_LOADING(false);
    }
  }

  async get_news_by_id(id: string | number) {
    try {
      const { data } = await newsServece.get_news_by_id(id);

      this.mutations.SET_DETAIL_NEWS(data);
    } catch (error) {
      console.error(error);
    }
  }

  async send_stats_by_id(id: string | number) {
    try {
      const payload = this.state.type_stats;
      const { code } = await newsServece.send_stats_by_id(id, payload);

      return code;
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.SET_TYPE_STATS('');
    }
  }
}
